module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-left social-nav"
  }, _vm._l((_vm.socialLinks), function(link, i) {
    return _c('a', {
      key: i,
      staticClass: "nav-item",
      attrs: {
        "href": link.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('iconify-icon', {
      attrs: {
        "icon": link.icon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sr-only"
    }, [_vm._v(_vm._s(link.name))])], 1)])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0369270a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SubscribeModule.vue
// module id = 754
// module chunks = 1